import { zodNumberNullable, zodStringNullable } from '@qapline/helpers';
import { z } from 'zod';

export const customerTypeSchema = z.enum(['ACTIVE', 'POTENTIAL']);

export const customerSchema = z.object({
    customer_id: z.number(),
    customerVersion_id: z.number(),
    type: customerTypeSchema,
    name: z.string(),
    defaultDueDate: zodNumberNullable(),
    city: zodStringNullable(),
    country: zodStringNullable(),
    countryCode: zodStringNullable(),
    postalCode: zodStringNullable(),
    street: zodStringNullable(),
    companyRegistrationNumber: zodStringNullable(),
    profilePicture: zodStringNullable(),
    taxId: zodStringNullable(),
    note: zodStringNullable(),
    billingEmail: zodStringNullable(),
    tsAdded: zodNumberNullable(),
    tsEdited: zodNumberNullable(),
    addedBy_id: zodNumberNullable(),
    editedBy_id: zodNumberNullable(),
    sameBillingAddress: z.boolean(),
    streetBilling: zodStringNullable(),
    cityBilling: zodStringNullable(),
    postalCodeBilling: zodStringNullable(),
    countryCodeBilling: zodStringNullable(),
});

export type TCustomer = z.infer<typeof customerSchema>;
export type TCustomerType = z.infer<typeof customerTypeSchema>;
